import { useState } from 'react'
import { Button, Input } from 'antd'
import './EditInput.scss'
import { t } from 'i18next'
import { EditOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'

const EditableInput = ({ value, onSave, title, setValue, type, handleEditValue }) => {
    const [isEditing, setIsEditing] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectId = userInfo?.user?.projectId

    const handleEdit = () => {
        setIsEditing(true)
    }

    const handleSave = async e => {
        if (e.key === 'Enter') {
            setIsLoading(true)
            if (typeof onSave === 'function') {
                if (type === 'sourceSystem') {
                    await onSave({ projectId, vibsNumber: value })
                } else {
                    handleEditValue(setIsEditing, setIsLoading)
                }
                setIsEditing(false)
                setIsLoading(false)
            }
        }
    }

    const handleSaveBtn = async e => {
        setIsLoading(true)
        if (type === 'sourceSystem') {
            await onSave({ projectId, vibsNumber: value })
        } else {
            handleEditValue(setIsEditing, setIsLoading)
        }
        setIsEditing(false)
        setIsLoading(false)
    }

    const handleChange = e => {
        if (/^\d*$/.test(e.target.value)) {
            setValue(e.target.value)
        }
    }

    return (
        <div className='editInput'>
            {isEditing ? (
                <span className='input'>
                    {title}：
                    <Input value={value} onChange={handleChange} onKeyDown={handleSave} />
                </span>
            ) : (
                <span className='input'>
                    {title}：<span className='inputText'>{value}</span>
                </span>
            )}
            <span className='editIcon' onClick={handleEdit}>
                {isEditing ? (
                    <Button className='editBtn' type='primary' loading={isLoading} onClick={handleSaveBtn}>
                        {t('Users.submitBtn')}
                    </Button>
                ) : (
                    <EditOutlined />
                )}
            </span>
        </div>
    )
}

export default EditableInput
